import { render } from "./AiKbbTradeValue.vue?vue&type=template&id=2d4fcc3b&scoped=true"
import script from "./AiKbbTradeValue.vue?vue&type=script&lang=js"
export * from "./AiKbbTradeValue.vue?vue&type=script&lang=js"

import "./AiKbbTradeValue.vue?vue&type=style&index=0&id=2d4fcc3b&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4fcc3b"],['__file',"src/Components/ChatWidget/AssistantAi/AiComponents/AiKbbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d4fcc3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d4fcc3b', __exports__)) {
    api.reload('2d4fcc3b', __exports__)
  }
  
  module.hot.accept("./AiKbbTradeValue.vue?vue&type=template&id=2d4fcc3b&scoped=true", () => {
    api.rerender('2d4fcc3b', render)
  })

}


export default __exports__